var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('b-container',{staticStyle:{"min-height":"80vh"},attrs:{"fluid":"","id":"main"}},[_c('b-row',[_c('b-col',{staticClass:"px-0",attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }